import styled from 'styled-components';

export const GroupMembersTitle = styled.h2`
  margin: 24px 0 0 0;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: -0.4px;
`;

export const GroupMembersList = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
